export default __webpack_public_path__ + "static/media/etapa3.bcf9da4c.png";